export function isMobile() {
  return window.matchMedia ? window.matchMedia('(max-width: 767px)').matches : window.innerWidth < 768;
}
